import { Popup } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { AddPersonWizard } from '../AddPersonWizard/AddPersonWizard';
import { addPersonWizardSteps } from '../AddPersonWizard/AddPersonWizard.constants';
import { useWizardStepIndex } from '../AddPersonWizard/AddPersonWizard.hooks';
import { messages } from './AddPersonPopup.messages';
import { addPersonPopupStepsState } from './AddPersonPopup.states';

export const AddPersonPopup = memo(() => {
    const stepIndex = useWizardStepIndex();
    const steps = useAtomValue(addPersonPopupStepsState);
    const hasSteps = steps?.length > 1;

    return (
        <>
            <Popup.Header
                title={messages.addPerson}
                subTitle={
                    hasSteps ? messages.stepOf({ index: stepIndex + 1, total: addPersonWizardSteps.length }) : undefined
                }
            />

            <Popup.Body spacing='20 32 32 32'>
                <AddPersonWizard />
            </Popup.Body>
        </>
    );
});

AddPersonPopup.displayName = 'AddPersonPopup';
